import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import logoa from "../assets/logo.svg";
import banner from "../assets/image_1.png";

import { Footer } from "../Template";
import { isMobile } from "react-device-detect";
import { Form, Spinner } from "react-bootstrap";
import imageCompression from "browser-image-compression";
import selfie_ktp from "../assets/selfie-ktp.png";
import axios from "axios";
import { useTranslation } from "react-i18next";
// import { jwtDecode } from "jwt-decode";

const API_URL = process.env.REACT_APP_URL_API;

const MobileSelfie = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [state] = useState({
    customerName: params.get("name") ?? null,
    token: params.get("token") ?? null,
  });
  const [isUploaded, setIsUploaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // const [expireTime, setExpireTime] = useState(null);
  // const [remainingTime, setRemainingTime] = useState(null);
  // const getExpireTime = (token) => {
  //   if (!token) return null; // No token provided

  //   try {
  //     const decoded = jwtDecode(token);
  //     // const currentTime = Date.now() / 1000; // Current time in seconds

  //     // Calculate remaining time
  //     // const remainingTime = decoded.exp - currentTime;
  //     return decoded.exp;
  //     // return remainingTime > 0 ? remainingTime : null; // Return null if expired
  //   } catch (error) {
  //     console.error("Error decoding token:", error);
  //     return null; // Return null if decoding fails
  //   }
  // };

  // useEffect(() => {
  //   setExpireTime(getExpireTime(state.token));
  // }, [state.token]);

  // useEffect(() => {
  //   if (expireTime) {
  //     setRemainingTime(expireTime - parseInt(Date.now() / 1000));

  //     // Optional: Set an interval to update remaining time
  //     const interval = setInterval(() => {
  //       setRemainingTime((prev) => prev - 1);
  //     }, 1000); // Update every second

  //     return () => clearInterval(interval); // Cleanup on unmount
  //   }
  // }, [expireTime]);

  const handleUploadSelfie = async (evt) => {
    setIsLoading(true);
    const name = evt.target.name;
    const value = evt.target.files[0];
    if (!value) return;

    if (name === "PHOTO") {
      const maxSizeMB = 0.38; // Change this to your desired size in MB
      const maxSizeBytes = maxSizeMB * 1024 * 1024;

      const options = {
        maxSizeMB, // Maximum size in MB
        useWebWorker: true, // Use a web worker for better performance
      };
      let compressedFile = value;
      if (compressedFile.size > maxSizeBytes) {
        try {
          compressedFile = await imageCompression(value, options);
        } catch (error) {
          console.error("Error compressing image:", error);
        }
      }
      if (compressedFile.size > maxSizeBytes) {
        this.setState({
          loadingForm: true,
          errMsg1: {
            ...this.state.errMsg1,
            [name]: `File size over ${maxSizeMB}MB`,
          },
        });
        return;
      }
      const formData = new FormData();
      formData.append("file", compressedFile);
      formData.append("tipe", name);

      const config = {
        headers: {
          Authorization: state.token ? `Bearer ${state.token}` : "",
          "x-app-origin": "cabinet-app",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      try {
        const { data } = await axios.post(
          API_URL + "/action-dokumen_pribadi",
          formData,
          config
        );
        if (data.error_message === 0) {
          setIsUploaded(true);
          setError("");
          setIsLoading(false);
        } else {
          setError("Unggah foto selfie gagal");
          setIsLoading(false);
        }
      } catch (err) {
        setIsLoading(false);
        console.log("Unggah foto selfie gagal", err);
        setError("Unggah foto selfie gagal");
      }
    }
  };

  document.getElementById("root").classList = "hold-transition";

  return (
    <>
      <div className="mobile-hide">
        <div class="w-full grid grid-cols-2 gap-4 bg-white">
          <div className="grid grid-cols-1 gap-0 place-items-center h-screen ">
            <div className="login-box ">
              <div className="card  border-white">
                <div className="card-header text-center h1 text-red-500 text-lg bg-white border-white grid grid-cols-1 place-items-center">
                  <div style={{ width: "75%" }}>
                    <img src={logoa} alt="" />
                  </div>
                  <div>
                    <b>
                      <span className="text-merah-button font-bold text-lg">
                        {t("upload_selfie.text_upload_selfie")}
                      </span>
                    </b>
                  </div>
                </div>
                <div className="card-body">
                  {isMobile ? (
                    <>
                      {!isUploaded ? (
                        <>
                          <h5>{`Hi, ${state.customerName}. Silahkan ambil foto selfie dengan KTP Anda di tangan.`}</h5>
                          <img
                            src={selfie_ktp}
                            style={{ maxWidth: "100%" }}
                            alt=""
                          />
                          <Form>
                            <Form.Group controlId="PHOTO">
                              <Form.File
                                id="input-file-selfie"
                                className="custom-file-input2"
                                accept="image/*"
                                size="lg"
                                name="PHOTO"
                                capture="user"
                                onChange={handleUploadSelfie}
                                hidden
                                disabled={isLoading}
                              ></Form.File>
                              <label
                                htmlFor="input-file-selfie"
                                className="btn btn-light border-1 border-black"
                              >
                                {isLoading ? (
                                  <div className="d-flex gap-2">
                                    <Spinner
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                    <span>Uploading...</span>
                                  </div>
                                ) : (
                                  <>{t("upload_selfie.text_take_selfie")}</>
                                )}
                              </label>
                            </Form.Group>
                          </Form>
                          {error && <h5 className="text-danger">{error}</h5>}
                        </>
                      ) : (
                        <h5>{t("upload_selfie.text_upload_success")}</h5>
                      )}
                    </>
                  ) : (
                    <h5>{t("upload_selfie.text_upload_only_mobile")}</h5>
                  )}
                  {/* {remainingTime && (
                    <div>Waktu tersisa: {remainingTime} detik</div>
                  )} */}
                </div>
              </div>
            </div>
          </div>

          <div className="show_hide h-auto overflow-hidden">
            <img src={banner} className="w-[100%] h-[100%]" alt="" />
          </div>
        </div>
      </div>

      <div className="mobile-view mb-5 mt-4">
        <div class="w-full grid grid-cols-2 gap-4">
          <div className="col-span-2 lg:col-span-0 grid grid-cols-1 gap-0 place-items-center">
            <div className="login-box">
              <div className="card  border-white">
                <div className="card-header text-center h1 text-red-500 text-lg bg-white border-white mt-4">
                  <div class="grid grid-cols-1 place-items-center">
                    <img src={logoa} width="60%" alt="" />
                  </div>
                  <b>
                    <span className="text-merah-button font-bold text-lg">
                      {t("upload_selfie.text_upload_selfie")}
                    </span>
                  </b>
                </div>
                <div className="card-body">
                  <div className="d-flex flex-column text-center gap-3 ">
                    {isMobile ? (
                      <>
                        {!isUploaded ? (
                          <>
                            <h5>{`Hi, ${state.customerName}. Silahkan ambil foto selfie dengan KTP Anda di tangan.`}</h5>
                            <img
                              src={selfie_ktp}
                              style={{ maxWidth: "100%" }}
                              alt=""
                            />
                            <Form>
                              <Form.Group controlId="PHOTO">
                                <Form.File
                                  id="input-file-selfie"
                                  className="custom-file-input2"
                                  accept="image/*"
                                  size="lg"
                                  name="PHOTO"
                                  capture="user"
                                  onChange={handleUploadSelfie}
                                  hidden
                                  disabled={isLoading}
                                ></Form.File>
                                <label
                                  htmlFor="input-file-selfie"
                                  className="btn btn-light border-1 border-black"
                                >
                                  {isLoading ? (
                                    <div className="d-flex gap-2">
                                      <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                      />
                                      <span>Uploading...</span>
                                    </div>
                                  ) : (
                                    <>{t("upload_selfie.text_take_selfie")}</>
                                  )}
                                </label>
                              </Form.Group>
                            </Form>
                            {error && <h5 className="text-danger">{error}</h5>}
                          </>
                        ) : (
                          <h5>{t("upload_selfie.text_upload_success")}</h5>
                        )}
                      </>
                    ) : (
                      <h5>{t("upload_selfie.text_upload_only_mobile")}</h5>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MobileSelfie;
